import { render } from "./UserSettingsButtonDropdown.vue?vue&type=template&id=aef7c924&scoped=true"
import script from "./UserSettingsButtonDropdown.vue?vue&type=script&lang=js"
export * from "./UserSettingsButtonDropdown.vue?vue&type=script&lang=js"

import "./UserSettingsButtonDropdown.vue?vue&type=style&index=0&id=aef7c924&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef7c924"]])

export default __exports__